module.exports = __webpack_public_path__ + "static/media/cq_messaggi_segna_tutti_come_letti b.c03c0f09.svg";